module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.filterHeading.length) ? _c('div', {
    staticClass: "u-margin-bottom-10 u-margin-right-20 flex-state-buttons"
  }, [_vm._v("\n        " + _vm._s(_vm.filterHeading) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('select', {
    ref: "input",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        return _vm.updateValue($event)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _vm._l((_vm.optionValues), function(key, value) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(value))])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2bc35727!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/filter/filterTypes/SelectFilter.vue
// module id = 1619
// module chunks = 0